import React from 'react'
import Hero from '../Components/Hero/Hero'
import Popular from '../Components/Popular/Popular'
import NewCollections from '../Components/New Collections/NewCollections'
import NewsLetter from '../Components/NewsLetter/NewsLetter'
import Categories from '../Components/Categories/Categories'
import Bride from '../Components/Bride/Bride'

const Shop = () => {
  return (
    <div>
      <Hero/>
      <Popular/>
      <Categories/>
      <Bride/>
      <NewCollections/>
      <NewsLetter/>
    </div>
  )
}

export default Shop 